import { Box, Typography, Container, Paper } from "@mui/material";

export function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: { xs: 2, md: 4 } }}>
        <Typography variant="h5" component="h1" gutterBottom fontWeight={600} color="#133859">
          Política de Privacidade – Sagrada Visão
        </Typography>

        <Typography variant="body2" color="text.secondary" gutterBottom>
          Última atualização: 10/01/2026
        </Typography>

        <Box mt={2}>
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            1. Introdução
          </Typography>
          <Typography variant="body2" paragraph>
            Esta Política de Privacidade explica como o Sagrada Visão coleta, usa e protege seus dados pessoais ao usar
            o aplicativo para se conectar com médicos oftalmologistas parceiros e agendar consultas.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            2. Dados que coletamos
          </Typography>
          <Typography variant="body2" paragraph>
            Podemos coletar informações como nome, e-mail, telefone, CPF, dados de login (senha criptografada) e
            informações relacionadas aos seus agendamentos (datas, horários e médico escolhido). Em alguns casos, podemos
            coletar dados de saúde relacionados ao seu atendimento, estritamente necessários para marcação e registro de
            consultas.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            3. Como usamos seus dados
          </Typography>
          <Typography variant="body2" paragraph>
            Utilizamos seus dados para criar e gerenciar sua conta, realizar e confirmar agendamentos, enviar lembretes,
            melhorar a experiência no aplicativo e cumprir obrigações legais. Os médicos parceiros podem acessar apenas as
            informações necessárias para realizar seu atendimento.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            4. Compartilhamento de informações
          </Typography>
          <Typography variant="body2" paragraph>
            Podemos compartilhar seus dados com médicos e clínicas parceiras, exclusivamente para fins de atendimento e
            gestão de consultas, e com prestadores de serviços que nos ajudam a operar o aplicativo (como provedores de
            hospedagem e envio de notificações). Não vendemos seus dados pessoais.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            5. Segurança dos dados
          </Typography>
          <Typography variant="body2" paragraph>
            Adotamos medidas técnicas e organizacionais para proteger seus dados contra acessos não autorizados,
            alterações, divulgações indevidas ou destruição. Nenhum sistema, porém, é 100% seguro. Caso identifiquemos
            algum incidente de segurança relevante, poderemos entrar em contato pelos canais cadastrados.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            6. Seus direitos
          </Typography>
          <Typography variant="body2" paragraph>
            Você pode solicitar a confirmação de tratamento de dados, acesso, correção de informações incorretas ou
            desatualizadas e, nos casos previstos em lei, a eliminação ou anonimização de dados. Também pode revogar
            consentimentos concedidos, quando aplicável, respeitadas as bases legais que nos permitam continuar tratando
            determinados dados.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            7. Cookies e tecnologias similares
          </Typography>
          <Typography variant="body2" paragraph>
            O Sagrada Visão pode utilizar cookies ou tecnologias similares para melhorar a navegação, lembrar suas
            preferências e entender como o aplicativo é utilizado. Você pode gerenciar essas configurações no próprio
            dispositivo ou navegador, ciente de que algumas funcionalidades podem ser impactadas.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            8. Retenção de dados
          </Typography>
          <Typography variant="body2" paragraph>
            Manteremos seus dados pessoais pelo tempo necessário para cumprir as finalidades descritas nesta Política,
            respeitando prazos legais e regulatórios aplicáveis. Após esse período, seus dados poderão ser eliminados ou
            anonimizados, salvo quando houver outra base legal para sua conservação.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            9. Contato
          </Typography>
          <Typography variant="body2" paragraph>
            Em caso de dúvidas sobre esta Política de Privacidade ou sobre o tratamento dos seus dados pessoais, você pode
            entrar em contato com o Sagrada Visão pelos canais oficiais informados no aplicativo ou em nosso site.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            10. Atualizações desta Política
          </Typography>
          <Typography variant="body2" paragraph>
            Esta Política de Privacidade pode ser atualizada periodicamente. Recomendamos que você a revise sempre que for
            notificado sobre alterações ou quando houver atualizações no aplicativo. O uso contínuo do Sagrada Visão após
            tais mudanças significa que você concorda com a nova versão da Política.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}
